import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import { Notification } from "ant-design-vue";
const athleteRepository = RepositoryFactory.get("athlete");
const userRepository = RepositoryFactory.get("users");

// Set Profile List
const setProfileList = ({ commit }) => {
  commit("loading", true)
  userRepository
    .getUsersInfo()
    .then(async response => {
      await commit("profileListSetter", response.data.athleteProfiles);
      await commit("loading", false)
    })
    .catch(error => {
      commit("loading", false)
      Notification.error({
        message: "Error",
        description: error.response.data.message
      });
    });
};

const setProfileData = ({ commit }, id) => {
  athleteRepository.getAthleteInfo(id).then(response => {
    commit("setEditProfileData", response.data.mainAthlete);
  });
};

// View Profile Data
const setViewProfileData = ({ commit }, data) => {
  commit("setViewProfileData", data);
};

// Player Profile Functions
const setGeneralInfo = ({ commit, state }, values) => {
  let toSend = {
    athleteId: state.athleteId,
    athletename: values.name,
    state: values.state,
    birthDay: values.day,
    birthMonth: values.month,
    birthYear: values.year,
    heightInFeet: values.feet,
    heightInInch: values.inch,
    weight: values.weight,
    profileType: "Incomplete"
  };
  if (values.country) {
    toSend.country = values.country;
  }
  athleteRepository.registerPlayer(toSend).then(response => {
    commit("addProfile", response.data.mainAthlete);
  });
};

const setPlayerDetailInfo = ({ commit }, { data, id }) => {
  athleteRepository
    .editPlayerData(data, id)
    .then(response => {
      Notification.success({ message: "Success" });
    })
    .catch(error => {
      Notification.error({ message: "Error", description: error.message });
    });
};

const addPlayerImages = ({ commit, state }, { data, id }) => {
  athleteRepository.postPlayerImages(data, id);
};

const addPlayerVideos = ({ commit }, { data, id }) => {
  let toSend = {
    atheleteMainProfileId: id,
    videoDesc: data.videoDesc,
    videoUrl: data.videoUrl
  };
  athleteRepository.postPlayerVideos(toSend);
};

const addPlayerTeams = ({ commit, state }, { data, id }) => {
  let toSend = {
    atheleteMainProfileId: id,
    name: data.name,
    level: data.level,
    position: data.position,
    coachName: data.coachName,
    coachEmail: data.coachEmail,
    coachPhone: data.coachPhone,
    slug: "athlete"
  };
  athleteRepository.postPlayerTeams(toSend);
};

export default {
  setProfileList,
  setProfileData,
  setViewProfileData,
  setGeneralInfo,
  setPlayerDetailInfo,
  addPlayerImages,
  addPlayerVideos,
  addPlayerTeams
};
